import { Box, Button, Stack, TextField, useMediaQuery, useTheme } from "@mui/material";
import HeaderWithBackNav from "../components/ui-header-back";
import PlayerInfoForm from "../components/player/player-info-form";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../types/store';
import AppActions from '../actions/app-actions';

import UIError from '../components/ui-error';
import Ongoing from '../components/popup/ongoing';

export default function Join() {
    const theme = useTheme();
    const { code } = useParams();
    const dispatch = useDispatch();
    const desktopView = useMediaQuery(theme.breakpoints.up("sm"));
    const [lobbyCode, setLobbyCode] = useState(parseInt(code ? code : "0"));
    const [error, setError] = useState<string|number>(0);
    const [name, setName] = useState("");
    const navigate = useNavigate();
    const join = useSelector((state:RootState) => state.page.join);
    const translate = useSelector((state:RootState) => state.ui.language.join);
    
    useEffect(() => {
        dispatch(AppActions.JoinLobbyReset());
        
        return () => {
            dispatch(AppActions.JoinLobbyReset());
        };
    }, []);
    
    useEffect(() => {
        if(join.error)
        {
            setError(join.error);
            return;
        }
        else if(join.code && join.code !== 0)
        {
            navigate(`/lobby/${join.code}`);
        }
        
    }, [join]);

    function onChangeLobbycode(e: React.ChangeEvent<HTMLInputElement>) {
        const num = parseInt(e.target.value);
        setLobbyCode(!isNaN(num) ? num : 0);
    }
    
    function onJoin() {
        setError(0);
        if (lobbyCode === 0) {
            setError(10);
            return;
        }
        if (name === "" || name.includes(" ")) {
            setError(402);
            return;
        }
        dispatch(AppActions.JoinLobby({nickname: name, code: lobbyCode}));
    }
    
    function onChangeName(name:string) {
        setName(name);
    }

    let error_message = join.error;
    if(error != 0) error_message = error;

    return (
        <center>
            <Ongoing />
            <Box bgcolor={desktopView ? theme.palette.secondary.main : ""} borderRadius={1} padding={2} width={desktopView ? "60%" : "100%"}>
                <HeaderWithBackNav text={translate.joinLobby} size={"md"} target="/" />
                <Stack gap={2}>
                    <TextField type="number" label={translate.lobbyCode} placeholder={translate.enterLobbyCode} onChange={onChangeLobbycode} InputLabelProps={{ shrink: (!code || code.length === 0) }} defaultValue={code} />
                    <PlayerInfoForm onChangeName={onChangeName} />
                    <UIError message={error_message} />
                    <Button variant="contained" disabled={join.isLoading} onClick={onJoin}>
                        {translate.joinLobby}
                    </Button>
                </Stack>
            </Box>
        </center>
    );
}
